import { forwardRef, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { InputProps } from '../types';
import { eyeOpenedIcon, eyeClosedIcon } from 'assets/icons';
import { BaseInput } from '../base-input';

/* Принимает в себя все пропсы BaseInput, подробно описаны в BaseInput. */
export const PasswordInput = observer(
  forwardRef<HTMLInputElement, InputProps>(
    ({ ...inputProps }, forwardedRef) => {
      const [showPassword, setShowPassword] = useState<boolean>(false);

      const toggleShowPassword = () => {
        setShowPassword((prevState) => !prevState);
      };

      return (
        <BaseInput
          ref={forwardedRef}
          type={showPassword ? 'text' : 'password'}
          actionIcon={{
            src: showPassword ? eyeOpenedIcon : eyeClosedIcon,
            action: toggleShowPassword,
          }}
          placeholder={'Введите пароль'}
          {...inputProps}
        />
      );
    }
  )
);
